module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 11 10",
      url: __webpack_public_path__ + "img/symbols.e4df9320ab0fa712c143543fa64d490c.svg#arrow",
      toString: function () {
        return this.url;
      }
    }